import { createId } from '@paralleldrive/cuid2';

const SESSION_COOKIE_MAX_AGE = 60 * 60 * 24 * 7; // 7 days

/**
 * Returns the shared `sessionId` cookie, creating it if missing.
 *
 * This is the same cookie sent as `externalData.SessionID` on reservations.
 * It is also included on tracking events so the backend can attribute the
 * whole journey (page views -> reservation -> move-in) to one session,
 * independently of the backend's express session cookie which is not sent
 * on cross-origin requests.
 */
export default function getOrCreateSessionId(): string {
    const match = document.cookie.match(/(?:^|;\s*)sessionId=([^;]+)/);
    if (match) {
        return decodeURIComponent(match[1]);
    }
    const sessionId = createId();
    document.cookie = `sessionId=${encodeURIComponent(sessionId)}; path=/; max-age=${SESSION_COOKIE_MAX_AGE}`;
    return sessionId;
}
